import type { SelectOption } from "@dmm-com/rocket-web-ui-library/es6/components/select";
import { isOpenAffiliateModalVar } from "~/components/stores/detail-product/store";
import { useAuth } from "~/provider/auth";

export type AffiliateOption = SelectOption & { optionKey: string; selected: boolean };

export const useAffiliateButtonAction = () => {
  const { isAffiliateOwner } = useAuth();

  const openAffiliateModal = () => isOpenAffiliateModalVar(true);

  return {
    viewableAffiliate: !!isAffiliateOwner,
    openAffiliateModal,
  };
};
